import * as datefns from 'date-fns'
import { firstElement, isSomething } from './utils'

// TODO: add tests

export const getOldestDate = (dates: (string | undefined | null)[]): string | undefined => 
  dates.filter(isSomething).sort().find(firstElement)

export const yearsSinceOldestDate = (dates: (string | undefined | null)[], format: string = 'yyyy-MM'): number | undefined => {
  const oldestDateString = getOldestDate(dates)

  if (!oldestDateString) return undefined
  const oldestDate = datefns.parse(oldestDateString, format, new Date())

  return datefns.differenceInYears(new Date(), oldestDate)
}